import { useQuery } from '@tanstack/react-query';

import { SEARCH, isSupabaseConfigured } from '@/config';
import { queryKeys } from '@/lib/data/keys';
import { searchAll } from '@/lib/data/provider';
import { useDebouncedValue } from '@/lib/utils/useDebouncedValue';

export function useSearch(rawQuery: string) {
  const query = useDebouncedValue(rawQuery.trim(), SEARCH.debounceMs);
  const active = query.length >= SEARCH.minQueryLength;
  const result = useQuery({
    queryKey: queryKeys.search(query),
    queryFn: () => searchAll(query),
    enabled: isSupabaseConfigured && active,
    staleTime: 1000 * 60,
  });
  return { ...result, active, debouncedQuery: query };
}
